module.exports = __webpack_public_path__ + "img/管理员.834596d2.svg";